<header
  class="w-full h-[84px] flex items-center justify-between border-b border-[#E4E7EC] px-3 sm:px-6 bg-white"
>
  <div class="flex items-center gap-2">
    <a [routerLink]="['/']" aria-label="Ir a inicio">
      <img
        [src]="cfg.project.logo"
        [alt]="'Logo ' + cfg.project.name"
        class="h-10 sm:h-12 w-auto cursor-pointer"
      />
    </a>
  </div>

  <div class="flex items-center gap-4">

    <!-- Usuario autenticado -->
    <div *ngIf="isLoggedIn" class="relative flex items-center gap-2">
      <!-- Botón que abre el menú -->
      <button
        pButton
        type="button"
        (click)="menu.toggle($event)"
        class="!bg-transparent !border-0 !p-0 flex items-center gap-2 hover:bg-gray-100 rounded-xl px-2 py-1.5"
        [attr.aria-expanded]="open()"
      >
        <p-avatar
          [label]="initial"
          shape="circle"
          [style]="{
            'background-color': avatarBg,
            color: '#fff',
            width: '32px',
            height: '32px'
          }"
        >
        </p-avatar>
        <span
          class="hidden sm:inline text-sm font-medium text-gray-700 max-w-[120px] md:max-w-[180px] truncate"
          [title]="displayName"
          >{{ displayName }}</span
        >
        <i
          class="pi"
          [ngClass]="
            open()
              ? 'pi-chevron-up text-gray-500'
              : 'pi-chevron-down text-gray-500'
          "
        ></i>
      </button>

      <!-- Menú emergente -->
      <p-menu
        #menu
        [popup]="true"
        [model]="items"
        appendTo="body"
        [baseZIndex]="10000"
        (onShow)="open.set(true)"
        (onHide)="open.set(false)"
      >
        <ng-template pTemplate="start">
          <div class="sm:hidden flex items-center gap-2 px-4 py-3 border-b border-gray-100">
            <p-avatar
              [label]="initial"
              shape="circle"
              [style]="{ 'background-color': avatarBg, color: '#fff', width: '32px', height: '32px' }"
            ></p-avatar>
            <span class="text-sm font-semibold text-gray-800 truncate max-w-[160px]" [title]="displayName">
              {{ displayName }}
            </span>
          </div>
        </ng-template>
      </p-menu>
    </div>

    <!-- Sin sesión -->
    <a
      *ngIf="!isLoggedIn"
      [routerLink]="['/login']"
      class="h-9 px-5 rounded-xl bg-brand-primary text-white text-sm font-medium flex items-center gap-2 hover:brightness-110"
    >
      <i class="pi pi-sign-in text-sm"></i>
      Iniciar sesión
    </a>

  </div>
</header>

<p-toast [life]="4000" position="top-right" styleClass="z-[10000]"></p-toast>
